import type { ExtendedFeaturesDto } from 'api/src/core/schemas/ProductSchema';
import { makeAutoObservable } from 'mobx';
import { defaultOnEmpty } from '../../../../../utils/object';
import Product from '../../../store/Product';
import BeforeInstall from '../beforeInstall/store/BeforeInstall';
import Download from '../download/store/Download';
import Rules from '../fileMovements/store/Rules';
import HiseLink from '../hiseLink/store/HiseLink';
import InstallDialog from '../installDialog/store/InstallDialog';
import ProductMerging from '../productMerging/store/ProductMerging';
import PulseVersion from '../pulseVersion/store/PulseVersion';

export type { ExtendedFeaturesDto };

export default class ExtendedFeatures {
  beforeInstall: BeforeInstall;
  download: Download;
  fileMovements: Rules;
  hiseLink: HiseLink;
  installDialog: InstallDialog;
  minPulseClientVersion: PulseVersion;
  productMerging: ProductMerging;

  constructor(
    dto: ExtendedFeaturesDto = {},
    product?: Product,
    private readonly onSave?: (features: ExtendedFeatures) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.beforeInstall = new BeforeInstall(dto.beforeInstall, this.save);
    this.download = new Download(dto.download, this.save);
    this.fileMovements = new Rules(dto.fileMovements, this.save);
    this.installDialog = new InstallDialog(dto.installDialog, this.save);
    this.hiseLink = new HiseLink(
      {
        ...dto.hiseLink,
        product: dto.hiseLink?.product || product?.name,
      },
      this.save,
    );
    this.minPulseClientVersion = new PulseVersion(
      dto.minPulseClientVersion,
      this.save,
    );
    this.productMerging = new ProductMerging(dto.isMergeable, this.save);
  }

  toJSON(): Required<ExtendedFeaturesDto> {
    return {
      beforeInstall: defaultOnEmpty(this.beforeInstall.toJSON()),
      download: defaultOnEmpty(this.download.toJSON()),
      fileMovements: defaultOnEmpty(this.fileMovements.toJSON()),
      hiseLink: defaultOnEmpty(this.hiseLink.toJSON()),
      installDialog: defaultOnEmpty(this.installDialog.toJSON()),
      isMergeable: defaultOnEmpty(this.productMerging.toJSON()),
      minPulseClientVersion: defaultOnEmpty(
        this.minPulseClientVersion.toJSON(),
      ),
    };
  }

  private async save() {
    return this.onSave?.(this);
  }
}
